import ButtonLoader from '@anm/components/buttons/ButtonLoader';
import { media } from '@anm/styles/helpers';
import styled from 'styled-components';

const saveButtonMobile = media.phone`
    margin: 0 auto;
`;

export const FormWrapper = styled.form``;

export const ButtonWrapper = styled.div`
  margin-top: 14px;
  text-align: center;
`;

export const ControlGroup = styled.fieldset`
  margin: 0;
  padding: 0;
  border: 0;

  input[type='password'] {
    font-size: 16px;
    line-height: 1.2;
    font-family: Inter;

    &::placeholder {
      font-size: inherit;
      color: #919eaa;
      letter-spacing: 0.01em;
    }
  }

  & > *:not(:last-child) {
    margin-bottom: 8px;
  }
`;

export const SaveButton = styled(ButtonLoader)`
  min-width: 190px;
  &:disabled {
    cursor: default;
  }
  ${saveButtonMobile};
`;

export const PasswordTip = styled.div`
  font-size: 16px;
  line-height: 22px;
  color: #292a2b;
  padding: 16px 22px 19px;
  background: #fff4db;
  border-radius: 5px;
  margin: 10px 0 18px;
`;
